import { type PartialDeep } from 'type-fest';

export enum PaywallFeature {
  SMART_CONNECTORS = 'smartConnectors',
  SMART_SECTIONS = 'smartSections',
  AI_GENERATE = 'aiGenerate',
  AI_CLUSTERING = 'aiClustering',
}

export type FeatureBody = {
  isEntitled: boolean;
};

export type PaywallFeatureState = {
  [feature in PaywallFeature]: FeatureBody;
};

export type ExpectedEntitlementFeatureBody = {
  whiteboards: Record<PaywallFeature, FeatureBody>;
};

/**
 * Technically anyone can change entitlement data in Confluence in a way that
 * could break this schema
 */
export type WhiteboardsEntitlementFeatureBody = PartialDeep<
  Record<PaywallFeature, FeatureBody>
>;

export type EntitlementFeatureBody = PartialDeep<{
  whiteboards?: WhiteboardsEntitlementFeatureBody;
}>;

/**
 * Note that an entitlement feature data comes from Commerce's entitlement template services
 *
 * Multiple teams from Confluence may modify the entitlement template. It's
 * unlikely that they would change whiteboarding features but for the sake of
 * avoiding an unnecessary HOT we assume that feature data fields may be
 * missing. Hence why this type exists in conjunction with {@link PaywallFeatureState}
 *
 * Moreover, it's possible that a tenant has not yet been migrated onto the
 * newest entitlement template, hence why this type assumes that a feature may
 * be missing.
 */
export type PaywallFeatureStateFromEntitlement = {
  [featureKey in PaywallFeature]?: PartialDeep<FeatureBody>;
};

/*
  Type guards against PaywallFeatureState and
  PaywallFeatureStateFromEntitlement going out of sync
 */
null as unknown as PaywallFeatureStateFromEntitlement satisfies PartialDeep<PaywallFeatureState>;
